import { createGtag, addGtag } from 'vue-gtag';

export default defineNuxtPlugin((nuxtApp) => {
  // Ne charger que sur le domaine de production
  const hostname = window.location.hostname;
  if (hostname !== 'donoor.org' && hostname !== 'www.donoor.org') {
    return;
  }

  // initMode "manual" + addGtag() différé (audit SEO 2026-07-11) : le plugin
  // s'installe de façon synchrone (les appels event() de useAnalytics restent
  // bufferisés dans le dataLayer — AUCUN événement perdu), mais la commande
  // gtag('config') n'est poussée qu'à l'idle, hors du chemin critique LCP/TBT.
  //
  // resource.inject = false (audit perf 2026-09-14) : vue-gtag N'INJECTE PLUS
  // son propre <script> gtag.js. Le site ne charge plus qu'UN SEUL conteneur
  // de base — celui de Google Ads, posé par le snippet inline de nuxt.config
  // (JS nu, sans dépendance, c'est le chemin qui porte l'argent). GA4
  // (G-CHDSZ5Q3WB) devient une destination SECONDAIRE de ce conteneur : gtag
  // la reconnaît au `config` ci-dessous et charge lui-même son petit payload.
  //
  // Mesuré avant : 3 fichiers gtag.js (G- 180 Ko + AW- 161 Ko + AW-&cx=c
  // 161 Ko = 502 Ko dont 265 Ko inutilisés, 323 ms de fil principal).
  // Après : 2 fichiers, ~165 Ko et ~110 ms de moins.
  //
  // Sens du risque volontairement choisi : si ce plugin casse, GA4 est perdu
  // mais la conversion Google Ads, elle, continue de partir.
  const gtag = createGtag({
    tagId: 'G-CHDSZ5Q3WB',
    initMode: 'manual',
    resource: { inject: false },
  });
  nuxtApp.vueApp.use(gtag);

  // addGtag() ne télécharge donc plus rien : il exécute la config initiale
  // (gtag('config', 'G-CHDSZ5Q3WB')), poussée dans le dataLayer. Toujours
  // différée après le premier rendu complet puis à l'idle — les event() de
  // useAnalytics restent bufferisés entre-temps, aucun événement perdu.
  const loadGtag = () => {
    addGtag();
  };
  const scheduleGtag = () => {
    if ('requestIdleCallback' in window) {
      requestIdleCallback(loadGtag, { timeout: 6000 });
    } else {
      setTimeout(loadGtag, 4000);
    }
  };
  if (document.readyState === 'complete') {
    scheduleGtag();
  } else {
    window.addEventListener('load', scheduleGtag, { once: true });
  }
});
